import { Grid } from "@material-ui/core";
import React, { Component } from "react";
// import "";

import { Redirect, Route, Switch } from "react-router-dom";

import routes from "../../routes";
import AuthLoading from "../Auth/AuthLoading";
import MainAppbar from "./Layout/MainAppbar";
import Sidebar from "./Layout/Sidebar";
import axios from "axios";
import Constants from "../Variables/Constants";
import Dashboards from "./Dashboard";
import { clearAuth } from "../../helpers/AuthHelpers";

import AddCategory from "../../AddViews/AddCategory";
import UpdateCategory from "../../UpdateViews/UpdateCategory";

import AddSubCategory from "../../AddViews/AddSubCategory";
import UpdateSubCategory from "../../UpdateViews/UpdateSubCategory";

import AddProducts from "../../AddViews/AddProducts";

import Add_Testimonial from "../../AddViews/AddTestimonials";
import Update_Testimonial from "../../UpdateViews/UpdateTestimonial";
import UpdateProducts from "../../UpdateViews/UpdateProducts";
import Variants from "./Variants";
import AddVariants from "../../AddViews/AddVariants";
import UpdateVariants from "../../UpdateViews/UpdateVariants";
import Order_Details from "./OrderDetails";
import AddBanner from "../../AddViews/AddBanner";
import UpdateBanner from "../../UpdateViews/UpdateBanner";
export default class Main extends Component {
  state = {
    loading: true,
    authenticated: false,
    role: "agent",
    profileData: [],
  };

  checkAuth = (status) => {
    if (status) {
      // console.log(status)
      this.setState({ loading: false, authenticated: true });
      this.getProfile();
    } else {
      // this.props.history.push("/login");
      this.setState({ loading: false, authenticated: false });
    }
  };

  getProfile = () => {
    axios
      .get(Constants.getUrls.getProfile)
      .then((res) => {
        if (res.data.status === "success") {
          this.setState({
            profileData: res.data.data || [],
          });
        }
      })
      .catch((error) => {
        const status = error?.response?.status;

        if (status === 401 || status === 403) {
          clearAuth();
          this.setState({
            authenticated: false,
            profileData: [],
          });
          return;
        }

        this.setState({
          profileData: [],
        });
      });
  };

  render() {
    return (
      <div>
        {this.state.loading ? <AuthLoading checkAuth={this.checkAuth} /> : null}
        {this.state.authenticated ? (
          <>
            <MainAppbar />

            <Grid container className="main">
              <Grid
                item
                style={{
                  position: "fixed",
                  width: "16.666667%",
                  marginTop: "70px",
                }}
                className="sidebar"
              >
                <Sidebar />
              </Grid>

              <Grid item xs={2} style={{ margin: "12px 0" }}></Grid>

              <Grid item xs={10} spacing={2} style={{ margin: "90px 0" }}>
                <Switch>
                  <Route path="/dashboard" component={Dashboards} />
                  {/* <Switch defau> */}
                  {routes.map((route, index) => (
                    <Route
                      exact={route.exact}
                      g
                      path={route.path}
                      // component={route.component} -- NOT WORKING
                      render={() => <route.component title={route.title} />}
                      key={index}
                    />
                  ))}

                  {/* {routes.Dashboard.map((route, index) => (
                    <Route
                      key={index}
                      exact={route.exact}
                      path={route.path}
                      element={route.component}
                      // render={() => <route.component title={route.title} />}
                      // component={route.component} -- NOT WORKING
                    />
                  ))}
                 
                  {routes.User.map((route, index) => (
                    <Route
                      key={index}
                      exact={route.exact}
                      path={route.path}
                      // element={route.component}
                      render={() => <route.component title={route.title} />}
                      // component={route.component} -- NOT WORKING
                    />
                  ))}
                  

                  
                  {routes.RulesOf_Game.map((route, index) => (
                    <Route
                      key={index}
                      exact={route.exact}
                      path={route.path}
                      // element={route.component}
                      render={() => <route.component title={route.title} />}
                      // component={route.component} -- NOT WORKING
                    />
                  ))} */}

                  <Route
                    path="/admin/addTestimonial"
                    component={Add_Testimonial}
                  />
                  <Route
                    path="/admin/updateTestimonial"
                    component={Update_Testimonial}
                  />

                  <Route path="/admin/addcategory" component={AddCategory} />
                  <Route
                    path="/admin/updatecategorys/"
                    component={UpdateCategory}
                  />
                  <Route
                    path="/admin/addsubcategory"
                    component={AddSubCategory}
                  />
                  <Route
                    path="/admin/updatesubcategorys/"
                    component={UpdateSubCategory}
                  />

                  <Route path="/admin/addproducts" component={AddProducts} />
                  <Route
                    path="/admin/updateproducts"
                    component={UpdateProducts}
                  />

                  <Route path="/admin/variants/" component={Variants} />
                  <Route path="/admin/addvariants/" component={AddVariants} />
                  <Route
                    path="/admin/updatevariants/"
                    component={UpdateVariants}
                  />

                  <Route path="/admin/orderDetails" component={Order_Details} />
                  <Route path="/admin/addbanner" component={AddBanner} />
                  <Route path="/admin/updatebanner" component={UpdateBanner} />

                  
                </Switch>
              </Grid>
            </Grid>
          </>
        ) : !this.state.loading ? (
          <Redirect to="/" />
        ) : null}
      </div>
    );
  }
}

// ) : !this.state.loading ? (
//   <Redirect to="/login" />
// ) : null}
